import * as React from "react";

const AusQuickOrder: React.FC = () => {
    return (
        <svg id="Layer_1" data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 498.97 570.97">
            <path
                d="M.46,307.92V268.09H113.67c11,3.9,16.51,11.82,18,23.26.95,7.23,3.72,14.29,4.16,21.51.6,9.64,5.11,11.55,14,11.53,107.61-.3,215.22,0,322.82-.39,12.65,0,21.56,3.73,26.73,15.37v10.48a9.85,9.85,0,0,0-1.57,2.63Q478.7,437,459.69,521.63c-4.37,19.57-9.23,23.76-29.06,23.76q-116.8,0-233.62,0H183.64c2.16,10.52,3.94,19.22,5.84,28.46H282.4c45.74,0,91.49-.09,137.24,0,16.52.05,25.34,10.93,22,26.46-1.38,6.41-2.7,12.84-4,19.12,3.34,2.46,6.23,4.39,8.91,6.58,26.38,21.47,23.09,62.91-6.48,79.71-5,2.85-10.71,4.54-16.09,6.77H409.28a39.2,39.2,0,0,0-4.7-2c-20.72-5.83-34.08-21.13-36.43-42.2-1.62-14.53,4.06-27,12.87-39H201.73c2.26,3.16,3.89,5.28,5.35,7.51,16.15,24.7,6.44,58.81-20.21,70.84-4,1.82-8.26,3.2-12.4,4.78H159.8c-2.59-.9-5.15-1.86-7.76-2.7-35-11.33-45.71-56.6-18.15-80.9,8.34-7.35,7.85-13.35,6-22.21-16-77.42-31.67-154.92-47.5-232.38-3.45-16.9-7.14-33.76-10.77-50.88-19.1,0-36.91-.48-54.68.17C14.28,324.11,5.32,319.86.46,307.92Z"
                transform="translate(-0.46 -135.58)"
                fill="#000000"
            />
            <path
                d="M429,17.55h0L184.83,285.16h117.1L202.27,502.9,455.93,222l-130.33.6Z"
                transform="translate(-0.46 -3.58)"
                fill="#000000"
            />
            <path
                d="M429,17.55h0m0,0-103.39,205,130.33-.6-253.66,281,99.66-217.74H184.83L429,17.55m0-14h-.53A13.82,13.82,0,0,0,422,5.47,14,14,0,0,0,418.78,8l-.14.14L174.5,275.74a14,14,0,0,0,10.33,23.39h95.33l-90.6,198a14,14,0,0,0,23.08,15.18L466.3,231.32A14,14,0,0,0,455.93,208h-.07l-107.51.49L441.22,24.36a14,14,0,0,0-12-20.78Zm0,28h0Z"
                transform="translate(-0.46 -3.58)"
                fill="#010101"
            />
        </svg>
    );
};

export default React.memo(AusQuickOrder);
